import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {VisitConfigurationModel} from "../../models/visit-configuration.model";
import {VisitConfigurationTotals} from "../../components/visit-configurations-view/visit-configurations-view.component";
import {ProcessTrackingModel} from "../../../commons/models/process-tracking.model";
import { ServiceType } from '../../../deliveries/types/service.type';
import { PricePlanProgramType } from '../../../price-plan/types/price-plan-program.type';

export interface CallTemplatesQuery {
  expirationDate: number;
  ids?: string[];
  accountIds?: string[];
  serviceTypes?: ServiceType[];
  programTypes?: PricePlanProgramType[];
  from?: number;
  to?: number;
  branchIds?: string[];
  searchTerm?: string;
}

@Injectable({providedIn: 'root'})
export class VisitConfigurationHttpService {

  private base_url: string = `/visit/configuration`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getMany(params?: CallTemplatesQuery): Observable<{ cursor: string, list: VisitConfigurationModel[] }> {
    return this.http
      .get<{ cursor: string, list: VisitConfigurationModel[] }>(this.base_url, {params: params as any});
  }

  getOne(id: string, params?: any): Observable<VisitConfigurationModel> {
    return this.http
      .get<VisitConfigurationModel>(`${this.base_url}/${id}`, {params})
  }

  createOne(visitConfiguration: VisitConfigurationModel, params?: any): Observable<VisitConfigurationModel> {
    return this.http
      .put<VisitConfigurationModel>(this.base_url, visitConfiguration, {params})
  }

  updateOne(id: string, visitConfiguration: VisitConfigurationModel, params?: any): Observable<VisitConfigurationModel> {
    return this.http
      .post<VisitConfigurationModel>(`${this.base_url}/${id}`, visitConfiguration, {params})
  }

  deleteOne(id: string, params?: any): Observable<VisitConfigurationModel> {
    return this.http
      .delete<VisitConfigurationModel>(`${this.base_url}/${id}`, {params})
  }

  getTotals(params?: any): Observable<VisitConfigurationTotals> {
    return this.http
      .get<VisitConfigurationTotals>(`${this.base_url}/totals`, {params});
  }

  expireMany(payload: CallTemplatesQuery, params?: any): Observable<ProcessTrackingModel> {
    const {expirationDate, ...queryParams} = payload;
    return this.http
      .post<ProcessTrackingModel>(`${this.base_url}/expire`, {expirationDate}, {params: {...queryParams, ...params}});
  }

  getProcessTracking(ids: string[]): Observable<ProcessTrackingModel[]> {
    return this.http
      .get<ProcessTrackingModel[]>('/planning/processTracking', {params: {ids}});
  }

}
